import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'underscore';

var fn = function fn($scope, $state, AccountBillingDetailsService, ModalService, $stateParams, supportPhone, $window, InsuranceSuiteMetadata, PaymentInstrumentService) {
    var ctrl = Object.create(BaseCtrl);
    var invoiceStatusTypelist = InsuranceSuiteMetadata.get('bc').types.getTypelist('InvoiceStatus');
    var invoicePaidStatusTypelist = InsuranceSuiteMetadata.get('bc').types.getTypelist('InvoicePaidStatus');
    var periodicityTypelist = InsuranceSuiteMetadata.get('bc').types.getTypelist('Periodicity');
    $scope.setinvoiceStream = function (info) {
        return info;
    };

    ctrl.init = function () {
        $scope.showDetailedSchedule = false;
        $scope.outstandingAmount = null;
        $scope.supportPhone = supportPhone;
        $scope.havedata = false;
        var groupState = void 0;
        if ($state.is('accounts.detail.payment.setup-changepayment')) {
            groupState = AccountBillingDetailsService.getInvoiceStreamDetails($stateParams.accountNumber, $stateParams.streamId);
        } else {
            groupState = AccountBillingDetailsService.getPaymentGroupPaymentInformation($stateParams.streamId);
        }
        $scope.groupStatePromise = groupState;

        groupState.then(function (info) {
            $scope.info = info;
            $scope.paymentInstrument = PaymentInstrumentService.createAutopayPaymentInstrument(info.paymentInstrument);
            $scope.havedata = true;
            $scope.outstandingAmount = {
                amount: _.reduce(info.invoiceSummary, function (sum, v) {
                    return sum + v.amountDue.amount;
                }, 0),
                currency: info.invoiceSummary.length > 0 ? info.invoiceSummary[0].amountDue.currency : 'unknown'
            };

            var firstPayment = _.min(_.filter(info.invoiceSummary, function (invoice) {
                return invoice.status !== 'paid';
            }), function (invoice) {
                return new Date(invoice.dueDate).getTime();
            });

            $scope.firstPayment = firstPayment === Infinity ? null : firstPayment; // _.min() returns Infinity for empty sets
        });
    };

    ctrl.cancel = function () {
        $state.transitionTo($state.$current.data.actions.cancel);
    };

    ctrl.invoiceStatusName = function (typeCode) {
        return typeCode ? invoiceStatusTypelist.getCode(typeCode).name : '';
    };

    ctrl.invoicePaidStatusName = function (typeCode) {
        return typeCode ? invoicePaidStatusTypelist.getCode(typeCode).name : '';
    };

    ctrl.periodicityName = function (typeCode) {
        return typeCode ? periodicityTypelist.getCode(typeCode).name : '';
    };

    ctrl.chargesOfInvoice = function (invoice) {
        return {
            amount: invoice.breakdown.taxes.amount + invoice.breakdown.charges.amount,
            currency: invoice.breakdown.taxes.currency || invoice.breakdown.charges.currency
        };
    };

    ctrl.goBack = function () {
        $window.history.back();
    };

    /**
     * Changes the payment source set up on an automatic payments invoice stream
     * @param {*} instrument - The payment instrument to switch to
     */
    ctrl.changePaymentAction = function (instrument) {

        $scope.changeAutopayPaymentMethodPromise = AccountBillingDetailsService.setPaymentGroupPaymentInformation($stateParams.accountNumber, $scope.info.internalId, instrument, []).then(function () {
            if ($state.is('accounts.detail.payment.setup-changepayment')) {
                $state.transitionTo('accounts.detail.payment.setup-changepayment-confirmation', {
                    accountNumber: $stateParams.accountNumber,
                    info: {
                        invoices: $scope.info.invoiceSummary,
                        firstPayment: $scope.firstPayment
                    }
                });
            }
        }, function (error) {
            ModalService.showError('billing.controllers.BillingSummaryCtrl.Changing payment method', 'billing.controllers.BillingSummaryCtrl.There was a problem changing the payment method');
        });
    };
    /**
     * Remove Auto payment method
     * 
     */
    ctrl.removePaymentAction = function () {
        $scope.removePaymentInstrument = { bankAccountData: null, creditCardData: null, paymentMethod: null };

        /*AccountBillingDetailsService.setPaymentGroupPaymentInformation(
           		
           		$stateParams.accountNumber,$scope.info.internalId, $scope, []).then(
               () => {
               	
               	$state.transitionTo('accounts.detail.payment.setup-removepayment-confirmation', {
                       accountNumber: $stateParams.accountNumber
                   });
                       
               }, (error) => {
                   ModalService.showError(
                       'Remove ACH',
                       'There was a problem on remove ACH'
                   );
               }
           );*/

        $state.transitionTo('accounts.detail.payment.setup-removepayment-confirmation', {
            accountNumber: $stateParams.accountNumber
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', 'billing.AccountBillingDetailsService', 'ModalService', '$stateParams', 'config.supportPhone', '$window', 'InsuranceSuiteMetadata', 'integration.PaymentInstrumentService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/billing/controllers/SetupChangePaymentCtrl.js
// module id = 1398
// module chunks = 0